import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { connect } from "react-redux";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import { ChargeTypeCreate } from "../../Partials/Dialog/ChargeTypeCreate";
import { ChargeTypeUpdate } from "../../Partials/Dialog/ChargeTypeUpdate";

import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";

class ChargeTypes extends Component {
  public state = {
    isDeleteChargeTypePopupOpen: false,
    currentChargeType: null,
    isDialogOpen: false,
    isUpdating: false,
    anchorEl: null
  };

  constructor(public props) {
    super(props);
  }

  protected openMenu = (event: any, chargeType: any): void => {
    this.setState({
      currentChargeType: chargeType,
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      isUpdating: false,
      currentChargeType: null
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });
  }

  public deleteChargeType = (chargeType: any): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_DELETE_START,
      payload: {
        chargeType: chargeType
      },
      onSuccess: () => this.setState({ isDeleteChargeTypePopupOpen: false })
    });
  }

  public addChargeType = (chargeType: object, callback?): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TYPE_CREATE_START,
        payload: {
          chargeType: chargeType
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            isDialogOpen: false,
            hasModifiedData: true
          });

          this.closeDialog();

          if (typeof callback === "function") {
            callback();
          }
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public saveChargeType = (chargeType, useHideSwitch): any => {
    const payload = {
      ...chargeType,
      id: this.state.currentChargeType?.id
    };

    if (useHideSwitch) {
      payload.removed = !this.state.currentChargeType?.removed;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_START,
      payload: {
        chargeType: {
          ...payload
        }
      },
      onSuccess: () => {
        const chargeType = [
          ...TypeContainer.getReceivableTypes()
            .filter(chargeType => !!chargeType && !chargeType.system)
            .sort((chargeType1, chargeType2) => {
              if (chargeType1.label.toLowerCase() > chargeType2.label.toLowerCase()) {
                return 1;
              }
    
              if (chargeType1.label.toLowerCase() < chargeType2.label.toLowerCase()) {
                return -1;
              }
    
              return  0;
            }), 
          ...TypeContainer.getPayableTypes()
            .filter(chargeType => !!chargeType && !chargeType.removed && !chargeType.system)
            .sort((chargeType1, chargeType2) => {
              if (chargeType1.label.toLowerCase() > chargeType2.label.toLowerCase()) {
                return 1;
              }
    
              if (chargeType1.label.toLowerCase() < chargeType2.label.toLowerCase()) {
                return -1;
              }
    
              return  0;
            })
          ].find(chargeType => chargeType?.id === this.state.currentChargeType?.id);

        this.setState({
          currentChargeType: chargeType
        });

        if (!useHideSwitch) {
          return this.closeDialog();
        }
      },
    });
  }

  public getDialogContent(): any {
    if (this.state.isUpdating) {
      return (
        <ChargeTypeUpdate
          {...this.props}
          chargeType={this.state.currentChargeType}
          onSaveType={this.saveChargeType}
          onCancelType={this.closeDialog}
        />
      );
    }

    return (
      <ChargeTypeCreate
        {...this.props}
        onSaveType={this.addChargeType}
        onCancelType={this.closeDialog}
      />
    );
  }

  public getChargeTypes(): any {
    return [
      ...TypeContainer.getReceivableTypes()
        .filter(chargeType => !chargeType?.system)
        .sort((chargeType1, chargeType2) => {
          if (chargeType1.label.toLowerCase() > chargeType2.label.toLowerCase()) {
            return 1;
          }

          if (chargeType1.label.toLowerCase() < chargeType2.label.toLowerCase()) {
            return -1;
          }

          return  0;
        }), 
      ...TypeContainer.getPayableTypes()
        .filter(chargeType => !chargeType?.system)
        .sort((chargeType1, chargeType2) => {
          if (chargeType1.label.toLowerCase() > chargeType2.label.toLowerCase()) {
            return 1;
          }

          if (chargeType1.label.toLowerCase() < chargeType2.label.toLowerCase()) {
            return -1;
          }

          return  0;
        })
      ]
      .map((chargeType, key: number) => {
        const isPayable = chargeType && chargeType.chargeClassId && chargeType.chargeClassId == ChargeClassContainer.pickIdFromLabel("Payable")

        return (
          <TableRow 
            hover 
            key={`chargeType-${key}`} 
            className={`clickable-entity`}
            onClick={() => {this.isUserHasAccess() && this.setState({currentChargeType: chargeType, anchorEl: null}, () => this.setState({isUpdating: true, isDialogOpen: true}))}}
          >
            <TableCell></TableCell>
            <TableCell style={{width: "50%"}}>{chargeType.label}</TableCell>
            <TableCell style={{width: "20%"}}>{isPayable ? this.trans("payable") : this.trans("receivable")}</TableCell>
            <TableCell style={{width: "20%"}}>
              {chargeType.removed && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <div className="list-label creation-type-label">
                    {this.trans("label-hidden")}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, chargeType)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.state.currentChargeType?.id === chargeType.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    disabled={!this.isUserHasAccess()}
                    onClick={() => this.setState({isUpdating: true, isDialogOpen: true, anchorEl: null})}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public render() {
    return (
      <div style={{width: "100%"}}>
        <div className="component-wrapper no-margin-top no-margin-right">
          <Card className="card no-padding">
            <div className="label-container" style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
              <div style={{flexDirection: "column"}}>
                <h3 className="card-title">
                  {this.trans("page/settings-tab/chargetypes-section/chargetypes-title")}
                </h3>
              </div>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({isDialogOpen: true})}
                  style={{marginRight: "25px"}}
                  disabled={!this.isUserHasAccess()}
                >
                  {this.trans("page/settings-tab/chargetypes-section/chargetypes-button/addchargetype")}
                </Button>
              </div>
            </div>
            <div className="table-container">
              <TableComponent
                {...this.props}
                dispatch={this.props.dispatch}
                headers={[
                  "", this.trans("charge-type-name"), this.trans("label-type"), "", ""
                ]}
                className="listing-table bank-accounts-listing-table"
                rows={this.getChargeTypes()}
              />
            </div>
          </Card>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("title-charge-type")}
          content={this.getDialogContent()}
          openLeavePrompt={this.state.isDialogOpen}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
          onClose={this.closeDialog}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("page/settings-tab/chargetypes-section/chargetypes-dialog/deletechargetype-title")}
          content={this.trans("page/settings-tab/chargetypes-section/chargetypes-dialog/deletechargetype-info",
            {
              label: this.state.currentChargeType ? this.state.currentChargeType.label : ""
            })
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          openLeavePrompt={this.state.isDeleteChargeTypePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteChargeTypePopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteChargeTypePopupOpen: false }, this.deleteChargeType(this.state.currentChargeType)); }}
          hideCross={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.chargeTypeCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ChargeTypes
);
